module.exports = __webpack_public_path__ + "img/logo-header.f7da8b04.png";